const gid = '__ROLLUP_PLUGIN_HOT_RUNTIME'

module.exports = { gid }
